// Env-derived runtime config, extracted from App.tsx (audit F2) so the editor modules and App share
// one source. Vite inlines import.meta.env at build time.
export const SYNC_URL = import.meta.env.VITE_SYNC_URL; // unset → local-only (offline)
// server-api base. '' → no cloud uploads (data-URL fallback) and integrations disabled.
export const API_URL = import.meta.env.VITE_API_URL ?? '';
export const TOKEN = import.meta.env.VITE_TOKEN ?? '';
export const USER_ID = import.meta.env.VITE_USER_ID ?? 'local';
